<template>
  <div class="HeroError">
    <div class="HeroError--inner">
      <div class="HeroError--content">
        <div class="HeroError--title">
          <h1 v-html="$i18n.t('timeout.body.title')">Sitzung abgelaufen</h1>
        </div>
        <article class="HeroError--lead">
          <p v-html="$i18n.t('timeout.body.text')">
            Leider ist Ihre Sitzung abgelaufen. Bitte starten Sie die
            Dateneingabe erneut.
          </p>
          <p v-html="$i18n.t('timeout.body.greetings')">Ihre Migros Bank</p>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ActivationTimeout",
  data() {
    return {};
  },
};
</script>
